import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

import { Butt, Break } from 'sc-ui';
import { get, find } from 'lodash';
import { Drawer, Alert } from 'antd';
import { Layout } from '../sc-ui/Layout';

const YourCode = styled.span`
    display: block;
    font-size: 16px;
    font-weight: bold;
    color: ${({ theme }) => theme.color.scGray};
`;
const YourPoints = styled(YourCode)`
    margin-top: 20px;
`;
const CodeTextBox = styled.div`
    width: 100%;
    height: 90px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 3px dashed #efa8c7;
    background-color: #ed1f7a0a;
    border-radius: 10px;
    margin-bottom: 10px;
`;
const CodeText = styled.span`
    display: block;
    text-align: center;
    font-size: 36px;
    font-weight: bold;
    letter-spacing: 2px;
    color: ${({ theme }) => theme.color.secondary};
`;
const ThingsList = styled.ul`
    padding-inline-start: 20px;
    margin: 25px 0;
`;
const UserList = styled.ol`
    padding-inline-start: 20px;
    margin: 10px 0;
`;
const ThingItem = styled.li`
    margin-bottom: 5px;
`;
const Pink = styled.span`
    font-weight: bold;
    color: ${({ theme }) => theme.color.secondary};
`;
const PointsText = styled.span`
    display: block;
    text-align: center;
    font-size: 32px;
    font-weight: regular;
    color: ${({ theme }) => theme.color.secondary};
    margin-bottom: 25px;
`;
const YourType = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
`;
const FancyType = styled.div`
    padding: 6px 12px;
    margin-left: 10px;
    border-radius: 5px;
    font-weight: bold;
    background-color: #d5efb3;
    border: 1px solid #c3e09d;
    color: #436d10;
    letter-spacing: 0.7px;
`;

const propTypes = {
    onClose: PropTypes.func.isRequired,
    visible: PropTypes.bool.isRequired,
    user: PropTypes.object.isRequired
};
const defaultProps = {};
const Referrals = ({ onClose, visible, user, history }) => {
    const refType = get(user, ['referrer_type']) || 'Default';
    const code = get(user, ['referral_code']);
    const points = get(user, ['referral_points']) || 0;
    const usersReferred = get(user, ['users_referred']) || [];
    const currPath = get(history, ['location', 'pathname']);
    const userPromos = get(user, ['user_promos']);
    const basicReferral = find(userPromos, { promo: { is_basic: true } });
    const numBasicReferrals = get(basicReferral, ['amount_remaining']);

    return (
        <Drawer
            title="Referrals"
            placement="right"
            closable
            onClose={onClose}
            visible={visible}
            zIndex={1050}
            width={320}
        >
            {refType !== 'DEFAULT' && (
                <YourType>
                    Account Type: <FancyType>{refType}</FancyType>
                </YourType>
            )}
            <YourCode>Your Referral Code:</YourCode>
            <CodeTextBox>
                <CodeText>{code}</CodeText>
            </CodeTextBox>
            {refType === 'AMBASSADOR' && (
                <React.Fragment>
                    <ThingsList>
                        <ThingItem>
                            Give this code to your followers for when they sign up and they'll get{' '}
                            <strong>30% off</strong> their first order.
                        </ThingItem>
                        <ThingItem>
                            You will earn <strong>$1.00 CAD</strong> for every smoothie they order
                            for 3 months after their sign-up date, paid weekly.
                        </ThingItem>
                        {/* <ThingItem>Referrals <Pink>STACK</Pink> - keep referring friends to keep getting <strong>30% off</strong>!</ThingItem> */}
                    </ThingsList>
                    <Break />
                    <YourPoints>Users you've referred:</YourPoints>
                    <PointsText>{usersReferred.length}</PointsText>
                    <YourPoints>Smoothies ordered by users:</YourPoints>
                    <PointsText>{points}</PointsText>
                    {/* {usersReferred.length > 0 && (
                        <UserList>
                            {usersReferred.map(user => (
                                <ThingItem>
                                    {user.first_name} {user.last_name}
                                </ThingItem>
                            ))}
                        </UserList>
                    )} */}
                </React.Fragment>
            )}
            {refType === 'DEFAULT' && (
                <React.Fragment>
                    <ThingsList>
                        <ThingItem>
                            Give this code to your friend when they sign up and they'll get{' '}
                            <strong>30% off</strong> their first order.
                        </ThingItem>
                        <ThingItem>
                            When your friend completes their first order, you'll get a Referral
                            Promo for <strong>30% off</strong> any future order.
                        </ThingItem>
                        <ThingItem>
                            Referral Promos <Pink>STACK</Pink> - keep referring friends to keep
                            getting <strong>30% off</strong>!
                        </ThingItem>
                    </ThingsList>
                    <Break />
                    <YourPoints>Unused Referrals:</YourPoints>
                    <PointsText>{numBasicReferrals}</PointsText>
                    <Layout.Horizontal justify="center">
                        <Butt.on
                            onClick={currPath === '/order' ? onClose : () => history.push('/order')}
                            style={{ margin: '0 auto' }}
                        >
                            REDEEM NOW
                        </Butt.on>
                    </Layout.Horizontal>
                </React.Fragment>
            )}
        </Drawer>
    );
};

Referrals.propTypes = {};
Referrals.defaultProps = {};

export default withRouter(Referrals);



// WEBPACK FOOTER //
// ./src/_components/Referrals.jsx